import React, { useRef } from "react";
import AppContainer from "../../../components/AppContainer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import ExportButton from "../../../components/ExportButton";
import CustomRangePicker from "../../../components/DateRangePicker";
import { Menu, MenuItem, Stack } from "@mui/material";
import CustomSelect from "../../../components/customSelect";
import { allIcons } from "../../../assets";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationNewAdmissions.json";
import DeleteAlert from "../../../components/Alerts/DeleteAlert";

const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const status = ["Paid", "Remain", "Not Paid"];

const headerData = [
  "ID",
  "Join Date",
  "Student Detail",
  // "Source",
  "Class",
  // "Admission Fee",
  "Current Fees Status",
  "Status",
  "Action",
];

const displayRows = [
  "_id",
  "date_time",
  "ed_student_detail",
  // "source",
  "ed_student_class",
  // "ed_student_fee",
  "ed_current_fees_status",
  "status",
  "actions",
];

const AllStudents = () => {
  const openDeleteAlert = useRef(null);

  const handleOpenDeleteDialog = (data) => {
    openDeleteAlert.current.openDialog({
      heading: "Confirmation!",
      warningText:
        "Are ,You sure You want to delete this student details permanently.You want be able to revert this!",
      note: "",
    });
  };

  const handleDeleteStudent = () => {
    openDeleteAlert.current.closeDialog();
  };

  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <ExportButton handleClick={() => console.log("helllo")} />
        <CustomRangePicker
          stackProps={{
            borderRadius: "6px",
            border: "1px solid #dddddd",
          }}
        />
      </Stack>
    );
  };

  const renderSearchers = () => {
    return (
      <Stack flex={1} direction={"row"} alignItems={"center"} gap={1}>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.classBlackIcon} width={16} />}
          placeholder={"By Class"}
        >
          {allClasses.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={20} />}
          placeholder={"Status"}
        >
          {status.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.cashBundleBlackIcon} width={20} />}
          placeholder={"Fee Structure"}
        >
          <MenuItem value={"Pay All"}>Pay All</MenuItem>
          <MenuItem value={"Installments"}>Installments</MenuItem>
        </CustomSelect>
      </Stack>
    );
  };
  return (
    <>
      <AppContainer
        primaryHeading={"All Students"}
        secondaryHeading={"View, add, edit and delete Students details."}
        headProps={renderRightPart()}
        showSerach={true}
        searchMenuProps={renderSearchers()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={displayRows}
          tableData={TableData}
          showActions={true}
          showEdit={true}
          showDelete={true}
          showStudentDetails={true}
          showDetail={true}
          handleDelete={handleOpenDeleteDialog}
          handleChangeStatus={() => console.log("hel")}
        />
      </AppContainer>
      <DeleteAlert ref={openDeleteAlert} handleDelete={handleDeleteStudent} />
    </>
  );
};

export default AllStudents;
